import { render, staticRenderFns } from "./WebshopTeaPackage.vue?vue&type=template&id=e46b7282&scoped=true&"
import script from "./WebshopTeaPackage.vue?vue&type=script&lang=js&"
export * from "./WebshopTeaPackage.vue?vue&type=script&lang=js&"
import style0 from "./WebshopTeaPackage.vue?vue&type=style&index=0&id=e46b7282&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e46b7282",
  null
  
)

export default component.exports